module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"txt":"Loading Data.."},"ar":{"txt":"تحميل البيانات ..،"}}')
  delete Component.options._Ctor
}
